export const CONTENT_EDITOR_LABEL = "Content editor";
export const LEAVE_CONTENT_EDITOR_LABEL = "Leave content editor";
export const EVENT_MANAGER_LABEL = "Event manager";
export const LEAVE_EVENT_MANAGEMENT_LABEL = "Leave event management";
